import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { CustomerModel, ServiceModelDto } from '../../../domain/models'
import {
  AssessmentSvg,
  IconEditSvg,
  IconTrashSvg,
  PinSvg,
  SessionSvg
} from '../../assets/icons/svgComponents'
import { SelectInput } from '../../components'
import AssesmentForm from '../../components/timeline/modal/assesment'
import FactForm from '../../components/timeline/modal/fact'
import ServiceForm from '../../components/timeline/modal/service'
import SessionForm from '../../components/timeline/modal/session'
import { useModalBox } from '../../contexts'
import * as S from './styles'
import DeleteServiceModal from '../../components/accordion-table/delete-service'

type ComponentProps = {
  customer?: CustomerModel
  services: ServiceModelDto[]
  setSelectedService: (e: any) => void
  selectedService: ServiceModelDto | undefined | null
  setServicesList: (e: any) => void
}

const Toolbar = ({
  customer,
  services,
  setSelectedService,
  setServicesList,
  selectedService
}: ComponentProps) => {
  const getObjService = (id: number): ServiceModelDto | undefined => {
    return services.find((el: ServiceModelDto) => {
      return el.cdServico === Number(id)
    })
  }
  const { modalBox } = useModalBox()
  const [value, setValue] = useState<any>()

  useEffect(() => {
    if (selectedService) {
      setValue(selectedService.cdServico)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedService])

  const handleOpenSessionModal = () => {
    if (value) {
      modalBox(
        <SessionForm cdServiceProps={getObjService(value)?.cdServico} />,
        'Validação de dados',
        '66%'
      )
    }
  }
  const handleOpenFactModal = () => {
    if (value) {
      modalBox(
        <FactForm cdServiceProps={getObjService(value)?.cdServico} />,
        'Novo Fato Relevante',
        '46%'
      )
    }
  }
  const handleOpenAssesmentModal = () => {
    modalBox(
      <AssesmentForm value={customer} service={selectedService} />,
      'Nova Avaliação Psicológica',
      '46%'
    )
  }

  const handleOpenServiceModal = (
    serviceCurrent?: ServiceModelDto | undefined
  ) => {
    modalBox(
      <ServiceForm
        customer={customer}
        currentService={serviceCurrent}
        setSelectService={setSelectedService}
      />,
      serviceCurrent ? 'Editar Serviço' : 'Novo Serviço',
      '35%'
    )
  }
  const handleOpenDeleteServiceModal = () => {
    modalBox(
      <DeleteServiceModal
        item={getObjService(value)}
        setServicesList={setServicesList}
      />,
      'Deletar Serviço',
      '35%'
    )
  }
  console.log(value)
  return (
    <S.ToolCard>
      <div className="row">
        <S.TitleCard className="service-type">
          <span className="input">
            Serviço:
            <SelectInput
              key={'service-tpe'}
              name={'service-tpe'}
              value={value}
              options={[
                ...(services as any).map((el: ServiceModelDto) => ({
                  label: el?.titulo,
                  value: el?.cdServico
                })),
                { label: 'Adicionar Novo Serviço', value: 'add_service' }
              ]}
              onChange={(e: any) => {
                setValue(e.target.value)
                setSelectedService(getObjService(e.target.value))
                if (e.target.value === 'add_service') {
                  setValue(null)
                  setSelectedService(null)
                  handleOpenServiceModal(undefined)
                }
              }}
            />
          </span>
          {!!value && (
            <span>
              Data Inicial:
              <p>
                {moment(getObjService(value)?.dataServico).format('DD/MM/YYYY')}
              </p>
            </span>
          )}
          <span>
            <S.ActionButtonCard
              disabled={!value}
              onClick={() => handleOpenServiceModal(getObjService(value))}
            >
              <IconEditSvg />
            </S.ActionButtonCard>
            <div className="ml">
              <S.ActionButtonCardCancel
                disabled={!value}
                onClick={() => handleOpenDeleteServiceModal()}
              >
                <IconTrashSvg />
              </S.ActionButtonCardCancel>
            </div>
          </span>
        </S.TitleCard>
      </div>
      <div className="actions-row">
        <S.ToolButton
          onClick={() => handleOpenSessionModal()}
          disabled={!value}
          className="add-session"
        >
          <SessionSvg />
          Sessão
        </S.ToolButton>
        <S.ToolButton onClick={() => handleOpenFactModal()} disabled={!value}>
          <PinSvg />
          Fato Relevante
        </S.ToolButton>
        {/* <S.ToolButton onClick={() => handleOpenAttachmentModal()}>
          <AttachmentSvg />
          Anexo
        </S.ToolButton> */}
        <S.ToolButton
          onClick={() => handleOpenAssesmentModal()}
          disabled={!value}
        >
          <AssessmentSvg />
          Avaliação Psicológica
        </S.ToolButton>
      </div>
    </S.ToolCard>
  )
}
export default Toolbar
